const defaultMediasiteRoot = location.pathname.includes('/Mediasite/streams/') ? '/Mediasite/streams' : '/Mediasite';

function updatePaths(mediasiteRoot) {
    Object.assign(Path, {
        ApplicationRoot: `${mediasiteRoot}/Play`,
        ApplicationScriptsRoot: `${mediasiteRoot}/Play/Dist`,
        PlayerService: `${mediasiteRoot}/PlayerService/PlayerService.svc/json`,
        FileServer: `${mediasiteRoot}/FileServer`,
        WebAppsApi: `${mediasiteRoot}/MyMediasite/webapps-api`
    });
}

export const AntiForgery = Object.seal({
    Header: 'X-SOFO-AntiForgeryHeader',
    Token: ''
});

export const Path = Object.seal({
    ApplicationRoot: '',
    ApplicationScriptsRoot: '',
    PlayerService: '',
    FileServer: '',
    WebAppsApi: ''
});

export function applyConfig({ mediasiteRoot, ...config }) {
    if (mediasiteRoot !== undefined) {
        updatePaths(mediasiteRoot ?? defaultMediasiteRoot);
    }

    if (config) {
        Object.assign(AntiForgery, config.AntiForgery);
        Object.assign(Path, config.Path);
    }
}

applyConfig({ mediasiteRoot: defaultMediasiteRoot });
